import { Component } from "react"
import PropTypes from "prop-types"
import { Select, MenuItem } from "@mui/material"
import { FACTOR_CATEGORY } from "helpers/shapes"
import "./style.scss"

export default class FactorCategorySelector extends Component {
  static propTypes = {
    category: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(FACTOR_CATEGORY).isRequired,
    setCategory: PropTypes.func.isRequired,
  }

  onChange = event => {
    const { setCategory } = this.props
    const { value } = event.target

    setCategory(value)
  }

  render() {
    const { categories, category } = this.props

    return <div className="modules_factor-category-selector">
      <Select
        variant="standard"
        className="factor-category-selector"
        value={category}
        onChange={this.onChange}
        disableUnderline
      >
        <MenuItem value="all">All Factors</MenuItem>
        {categories.map((category) =>
          <MenuItem value={category.id} key={category.id}>{`${category.label} Factors`}</MenuItem>,
        )}
      </Select>
    </div>
  }
}
